// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__293-O","content":"styles_content__1CeSJ"};